<div class="modal-header">
  <h4 class="modal-title pull-left">Add Client</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <app-contact-edit [contact]="client" [isClient]="true" [isModal]="true"
                    (changesSaved)="saveChanges()"></app-contact-edit>
</div>
<div class="modal-footer">
</div>

